import { supabase } from "./supabaseClient";

const PHOTO_BUCKET = "Registration_data";

/**
 * Resolve a participant profile photo URL from registration.additional_data.
 * Supports storage paths and full public URLs.
 */
export function getPhotoUrlFromAdditionalData(additionalData) {
    if (!additionalData) return null;

    let data = additionalData;
    if (typeof additionalData === "string") {
        try {
            data = JSON.parse(additionalData);
        } catch {
            return null;
        }
    }

    let photo = data?.documents_photograph_url;
    if (Array.isArray(photo)) {
        photo = photo[0];
    }
    if (!photo || typeof photo !== "string") return null;

    const trimmed = photo.trim();
    if (!trimmed) return null;

    if (
        trimmed.startsWith("http://") ||
        trimmed.startsWith("https://") ||
        trimmed.startsWith("data:")
    ) {
        return trimmed;
    }

    const { data: urlData } = supabase.storage
        .from(PHOTO_BUCKET)
        .getPublicUrl(trimmed);

    return urlData?.publicUrl || null;
}
